import _ from 'lodash';
import React from 'react';
import postal from 'postal';
import Loading from '../../../shared/loading';
import defaultOnErrorHandler from '../../../shared/default-on-error-handler';
import ErrorBoundary from '../../../shared/error-boundary';
import {
  SortableFilterableTableHeader,
  SORT_DIRECTION,
  filterSimpleColumn,
  sortSimpleColumn,
} from '../../../shared/sortable-filterable-table-header';
import LivewireEvent from './livewire-event';
import EditLivewireEventModal from './edit-livewire-event-modal';
import { getAllEvents } from '../../../services/lwadmin/livewire-events/events-service';

function filterEvents(events, state) {
  let filteredEvents = _(events);

  filteredEvents = filterSimpleColumn(filteredEvents, 'name', state);
  filteredEvents = filterSimpleColumn(filteredEvents, 'slug', state);

  return filteredEvents.value();
}

function sortEvents(events, state) {
  let sortedEvents = _(events);

  sortedEvents = sortSimpleColumn(sortedEvents, 'name', state);
  sortedEvents = sortSimpleColumn(sortedEvents, 'slug', state);
  sortedEvents = sortSimpleColumn(sortedEvents, 'startsAt', state);

  return sortedEvents.value();
}

function filterAndSortEvents(events, state) {
  return sortEvents(filterEvents(events, state), state);
}

export default class LivewireEventsTable extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      allEvents: [],
      events: [],
      nameSortDirection: SORT_DIRECTION.unsorted,
      nameFilter: '',
      slugSortDirection: SORT_DIRECTION.unsorted,
      slugFilter: '',
      startsAtSortDirection: SORT_DIRECTION.unsorted,
    };
  }

  componentDidMount() {
    postal.subscribe({
      channel: 'lwadmin.livewire-events.commands',
      topic: 'create-event',
      callback: () => this.createEvent(),
    });

    this.refresh();
  }

  createEvent() {
    this.editLivewireEventModal.present();
  }

  refresh() {
    this.loading.start();
    getAllEvents()
      .then(result => {
        this.setState(state => {
          state.allEvents = result.data.events.map(e => new LivewireEvent(e));
          state.events = filterAndSortEvents(state.allEvents, state);
          return state;
        });
      })
      .catch(e => defaultOnErrorHandler(e, 'Error loading events'))
      .finally(() => this.loading.stop());
  }

  hideEvent(ce, event) {
    ce && ce.preventDefault && ce.preventDefault();

    this.setState(state => _(state.events).find({ id: event.id }).hide());
  }

  showEvent(ce, event) {
    ce && ce.preventDefault && ce.preventDefault();

    this.setState(state => _(state.events).find({ id: event.id }).show());
  }

  editEvent(ce, event) {
    ce && ce.preventDefault && ce.preventDefault();

    this.editLivewireEventModal.present(event);
  }

  sortName(direction) {
    this.setState(state => {
      state.nameSortDirection = direction;
      state.events = filterAndSortEvents(state.allEvents, state);
      return state;
    });
  }

  filterName(filter) {
    this.setState(state => {
      state.nameFilter = filter;
      state.events = filterAndSortEvents(state.allEvents, state);
      return state;
    });
  }

  sortSlug(direction) {
    this.setState(state => {
      state.slugSortDirection = direction;
      state.events = filterAndSortEvents(state.allEvents, state);
      return state;
    });
  }

  filterSlug(filter) {
    this.setState(state => {
      state.slugFilter = filter;
      state.events = filterAndSortEvents(state.allEvents, state);
      return state;
    });
  }

  sortStartsAt(direction) {
    this.setState(state => {
      state.startsAtSortDirection = direction;
      state.events = filterAndSortEvents(state.allEvents, state);
      return state;
    });
  }

  render() {
    return (
      <ErrorBoundary>
        <div className="lwadmin-livewire-events-table">
          <Loading ref={c => (this.loading = c)}>
            <table className="table table-hover">
              <thead>
                <tr>
                  <SortableFilterableTableHeader
                    onSort={direction => this.sortName(direction)}
                    onFilter={filter => this.filterName(filter)}
                  >
                    Name
                  </SortableFilterableTableHeader>
                  <SortableFilterableTableHeader
                    onSort={direction => this.sortSlug(direction)}
                    onFilter={filter => this.filterSlug(filter)}
                  >
                    Slug
                  </SortableFilterableTableHeader>
                  <SortableFilterableTableHeader
                    onSort={direction => this.sortStartsAt(direction)}
                  >
                    Starts at
                  </SortableFilterableTableHeader>
                  <th>Eventbrite ID</th>
                  <th>Rollover EB ID</th>
                  <th>Include Digital Pass</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {this.state.events.map(event => (
                  <tr key={event.id}>
                    <td>
                      {
                        event.hidden
                          ? (
                            <span>
                              <strike>{event.name}</strike>
                              {' (hidden)'}
                            </span>
                          )
                          : event.name
                      }
                    </td>
                    <td>{event.slug}</td>
                    <td>
                      {`${event.starts_at_time} ${event.starts_at.format('LL')}`}
                    </td>
                    <td>{event.eventbrite_id}</td>
                    <td>{event.rollover_eventbrite_id}</td>
                    <td>{event.include_digital_pass ? 'Yes' : 'No'}</td>
                    <td className="table-tools">
                      <ul>
                        <li><a href={`/events/${event.slug}`}>View</a></li>
                        <li><a href="#" onClick={e => this.editEvent(e, event)}>Edit</a></li>
                        <li>
                          <a
                            href="#"
                            onClick={e => this[`${event.hidden ? 'show' : 'hide'}Event`](e, event)}
                          >
                            {event.hidden ? 'Show' : 'Hide'}
                          </a>
                        </li>
                      </ul>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Loading>
          <EditLivewireEventModal
            ref={c => (this.editLivewireEventModal = c)}
            eventDidSave={() => this.refresh()}
          />
        </div>
      </ErrorBoundary>
    );
  }
}
